/**
 * Tests if candidate is a subset of array
 */
export function isSubset(candidate: any[], array: any[]): boolean {
    /* Set.prototype.has is required by the ECMAScript spec to be
     * implemented in sub-linear time, so by converting array to Set
     * we can avoid n^2 complexity. (In WebKit, Sets are HashMaps
     * internally, so has() is constant time) */
    const set = new Set<any>(array);
    for (const member of candidate) {
        if (!set.has(member)) {
            return false;
        }
    }
    return true;
}
